import { computedFrom, autoinject } from 'aurelia-framework';
import { PageMessageService } from "../../services/page-message-service";
import { WebApiService } from "../../services/web-api-service";
import { SecurityService } from '../../services/security-service';
import { BusyService } from '../../services/busy-service';

@autoinject
export class ChangePassword {
    emailSent: boolean;

    constructor(
        private pageMessageService: PageMessageService) {
    }

    activate(parameters) {
    }

    login() {
        (<any>window.location) = "login";
    }
}

